import { HiOutlineMail } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";

const data = [
  { id: 1, icon: <HiOutlineMail />, link: "mailto:getintouch@raphaelsaab.com" },
  { id: 3, icon: <FaWhatsapp />, link: "https://wa.me/+96176150360" },
];

export default data;
